// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesignTile_wrapper__3hn10","hover":"DesignTile_hover__3O9jq","title":"DesignTile_title__3uMGP"};